import { Box, BoxProps } from "@chakra-ui/react";
import { FiArrowRight } from "react-icons/fi";

export const ArrowRightIcon = (props: BoxProps) => {
  return <Box as={FiArrowRight} height="20px" width="20px" {...props} />;
};
